<template>
		<div class="home-page-bot">
      <div class="top-nav header-content">
        <div class=" disflex" style="justify-content: space-between;">
          <div class="chances-top disflex crfff ac">
            <div @click="back">
              <img src="../../static/images/back.png"  class="nav-icon-left" />
              <div>{{$t('Back')}}</div>
            </div>
          </div>
          <a class="logo logo-w" href="/"><img src="static/images/snapbot-logo.png" /></a>
          <div class="account-top disflex crfff ac" @click="getMenu()" @click.stop>
            <div>
              <img width="20" src="static/images/menu-i.png">
              <div>{{$t('Menu')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-bg" v-if="isActive"></div>
      <div class="menu-bg" v-if="isActive">
        <div class="disflex mt50" style="justify-content: flex-start;">
          <img width="25" @click="isActive=false" src="../../static/images/back.png" />
          <a class="logo" style="margin: 0 0 0 0.64rem;" href="/"><img src="static/images/snapbot-logo.png" /></a>
        </div>
        <div class=" ac mt100">
          <div class="chances-bt crfff"  @click="newChat"><img width="16" style="margin-right: 5px;" src="../../static/images/New-Chat.png">{{$t('New Chat')}}</div>
        </div>
        <div class="Delete-Chat fw7 ac mt50" @click="newChat">
          <img width="14" style="vertical-align: middle;" src="static/images/Delete-Chat.png" />
          {{$t('Delete Chat')}}
        </div>
      </div>
      <!-- 聊天内容容器 -->
      <div class="chat-container chat-bg1" v-if="!messages.length">
        <!-- 欢迎内容 -->
        <div >
          <div class="welcome-box">
            <img style="width: 70%;" src="../../static/images/snapbot-img.png" alt="logo" />
            <h2 style="color: white;font-size: 0.4rem">{{$t('snapbot_hi')}}</h2>
            <p style="color: white;font-size: 0.25rem;margin-top: 5px">{{$t('help_today')}}</p>
          </div>
          <div class="snapbot-block">
            <div class="snapbot-li">
              <img src="../../static/images/bot-img1.png">
              <div class="font">{{$t('snapbotTips1')}}</div>
            </div>
            <div class="snapbot-li">
              <img src="../../static/images/bot-img2.png">
              <div class="font">{{$t('snapbotTips2')}}</div>
            </div>
            <div class="snapbot-li">
              <div class="new">{{$t('New')}}</div>
              <img src="../../static/images/bot-img3.png">
              <div class="font">{{$t('snapbotTips3')}}</div>
            </div>
            <div class="snapbot-li">
              <div class="new">{{$t('New')}}</div>
              <img src="../../static/images/bot-img4.png">
              <div class="font">{{$t('snapbotTips4')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-container chat-bg2" v-else>
        <!-- 消息列表 -->
        <div class="message-list">
          <div v-for="(msg, index) in messages" :key="index"
               :class="['message', msg.role]">

            <!-- 如果是机器人，显示头像在左侧 -->
            <img v-if="msg.role === 'assistant'" class="avatar" src="../../static/images/snapbot_icon.png" alt="bot" />

            <div class="bubble">
              <!-- 图片显示 -->
              <div v-if="msg.type === 'image' && msg.image_url" class="message-image">
                <img :src="msg.image_url" alt="Image" class="message-image-preview" />
              </div>

              <!-- 文件显示 -->
              <div v-if="msg.type === 'file' && msg.file_name" class="message-file">
                <img src="../../static/images/file.png" alt="File" class="message-file-icon" />
                <span class="message-file-name">{{ msg.file_name }}</span>
              </div>

              <!-- 消息内容 -->
              <span v-if="msg.loading">{{$t('think_ip')}}</span>
              <span v-else-if="msg.content" class="message-content">{{ msg.content }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 文件预览区域 -->
      <div class="file-preview-area" v-if="selectedImage || selectedFile">
        <div class="preview-item" v-if="selectedImage">
          <img :src="imagePreview" alt="Preview" class="preview-image" />
          <div class="preview-close" @click="clearImage">×</div>
        </div>
        <div class="preview-item" v-if="selectedFile">
          <img src="../../static/images/file.png" alt="File" class="preview-file-icon" />
          <span class="preview-file-name">{{ selectedFile.name }}</span>
          <div class="preview-close" @click="clearFile">×</div>
        </div>
      </div>
      <!-- 输入框区域 - 始终显示 -->
      <div class="chat-botttom disflex">
        <div class="" @click="showBottomSheet = true">
          <img src="../../static/images/new_chat.png"  class="nav-icon" />
        </div>
        <div class="chat-input-box" >
          <input
            v-model="message"
            type="text"
            class="chat-input"
            :placeholder="$t('snapbotInput1')"
            @focus="handleInputFocus"
            @blur="handleInputBlur"
          />
          <button class="send-btn" :class="{ disabled: isBotThinking }" @click="sendMessage">
            <img style="height: 0.7rem;margin-right: 0.1rem" :src="isBotThinking ? '../../static/images/send.png' : '../../static/images/send-active.png'" alt="Send" class="send-icon" />
          </button>
        </div>
      </div>
      <!-- 底部弹窗 -->
      <div class="modal-bg" v-if="showBottomSheet" @click="showBottomSheet = false"></div>
      <div class="bottom-sheet" :class="{ 'show': showBottomSheet }">
        <div class="bottom-sheet-handle" @click="showBottomSheet = false"></div>
        <div class="bottom-sheet-content">
          <div class="upload-options">
            <div class="upload-btn" @click="uploadPhoto">
              <img src="../../static/images/image_icon.png" alt="Camera" class="upload-icon" />
              <span>{{$t('image')}}</span>
            </div>
            <div class="upload-btn" @click="uploadFile">
              <img src="../../static/images/file.png" alt="Files" class="upload-icon" />
              <span>{{$t('file')}}</span>
            </div>
          </div>
          <div class="new-chat-btn" @click="newChat">
            <img src="../../static/images/Delete-Chat.png" alt="New Chat" class="new-chat-icon" />
            <span>{{$t('new_chat')}}</span>
          </div>
        </div>
      </div>
      <!-- 隐藏的文件输入 -->
      <input ref="photoInput" type="file" accept="image/png,image/jpg,image/jpeg,.png,.jpg,.jpeg" capture="environment" style="display: none" @change="handlePhotoSelect" />
      <input ref="fileInput" type="file" accept=".txt,.csv,.xlsx,.xls" style="display: none" @change="handleFileSelect" />
		</div>
</template>
<script>
import Header from '../components/Header'

import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {

    return {
      score:0,
      mobile:"",
      isShowHeader:true,
      message: '',
      messages: [],
      suggestions: [],
      isKeyboardVisible: false,
      isBotThinking: false,
      isActive:false,
      showBottomSheet: false,
      selectedImage: null,
      selectedFile: null,
      imagePreview: ''
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
		this.chaHistory();
	},
  methods: {
    getMenu(){
      this.isActive = true;
    },
		back(){
			this.$router.push({path:'/'})
		},
		getHome(){
			let that =this;
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score=r.data.score
          that.mobile=r.data.mobile
        });
			})
		},
    chaHistory(){
      let that =this;
      that.$api.get('/api/snapbot/history',null,r =>{
        that.$parent.returnCode(r,function(){
          setTimeout(() => {
            that.messages.push(...r.data.history);

            // DOM 更新后再滚动到底部
            that.$nextTick(() => {
              const container = document.querySelector('.message-list');
              container.scrollTop = container.scrollHeight;
            });
          }, 1000);
        });
      })
    },
    sendMessage() {
      // 确定消息类型
      let type = 'text';
      if (this.selectedImage) {
        type = 'image';
      } else if (this.selectedFile) {
        type = 'file';
      }

      // 如果是纯文字类型，必须有消息内容
      if (type === 'text' && !this.message.trim()) {
        return;
      }

      // 构建用户消息对象
      let userMessage = {
        content: this.message || '',
        role: 'user',
        type: type
      };

      // 如果是图片类型，添加图片预览
      if (type === 'image' && this.selectedImage) {
        userMessage.image_url = this.imagePreview;
      }

      // 如果是文件类型，添加文件信息
      if (type === 'file' && this.selectedFile) {
        userMessage.file_name = this.selectedFile.name;
      }

      this.messages.push(userMessage);

      this.isBotThinking = true; // 锁住输入

      const loadingMsg = { content: 'Thinking...', role: 'assistant', loading: true };
      // 添加临时 loading 消息
      this.messages.push(loadingMsg);

      this.$nextTick(() => {
        const container = document.querySelector('.message-list');
        container.scrollTop = container.scrollHeight;
      });

      let that = this;

      // 创建FormData
      const formData = new FormData();
      formData.append('type', type);
      formData.append('message', this.message || '');

      if (type === 'image' && this.selectedImage) {
        formData.append('image', this.selectedImage);
      } else if (type === 'file' && this.selectedFile) {
        formData.append('file', this.selectedFile);
      }

      // 使用FormData上传
      that.$api.post('/api/snapbot/chat', formData, r => {
        that.$parent.returnCode(r, function(){
          // 替换 loading 消息
          const index = that.messages.findIndex(msg => msg.loading);
          if (index !== -1) {
            that.messages.splice(index, 1, {
              content: r.data.message,
              role: 'assistant',
              type: 'text',
              image_url: '',
              file_name: ''
            });
          }
        });

        that.isBotThinking = false; // 解除锁定

        // DOM 更新完再滚动
        that.$nextTick(() => {
          const container = document.querySelector('.message-list');
          container.scrollTop = container.scrollHeight;
        });
      });

      // 清空输入和文件
      this.message = '';
      this.clearImage();
      this.clearFile();
    },
    handleInputFocus() {
      this.isKeyboardVisible = true;
      // 滚动到底部确保输入框可见
      setTimeout(() => {
        const container = document.querySelector('.message-list');
        container.scrollTop = container.scrollHeight;
      }, 300);
    },
    handleInputBlur() {
      this.isKeyboardVisible = false;
    },
    newChat(){
      this.messages = [];
      this.isActive = false;
      this.showBottomSheet = false;
      let that =this;
      that.$api.get('/api/snapbot/del',null,r =>{
        that.$parent.returnCode(r,function(){

        });
      })
    },
    uploadPhoto(){
      this.showBottomSheet = false;
      this.$refs.photoInput.click();
    },
    uploadFile(){
      this.showBottomSheet = false;
      this.$refs.fileInput.click();
    },
    handlePhotoSelect(event){
      const file = event.target.files[0];
      if (file) {
        // 检查文件格式（只允许 png, jpg, jpeg）
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];
        const allowedExtensions = ['png', 'jpg', 'jpeg'];
        const fileExtension = file.name.split('.').pop().toLowerCase();
        const fileType = file.type.toLowerCase();

        if (!allowedTypes.includes(fileType) && !allowedExtensions.includes(fileExtension)) {
          this.$utils.alertText(this.$t('invalid_image_format'), 200);
          event.target.value = '';
          return;
        }

        // 检查文件大小（最大5MB）
        const maxSize = 5*1024 * 1024; // 1MB
        if (file.size > maxSize) {
          this.$utils.alertText(this.$t('image_max_size'), 200);
          event.target.value = '';
          return;
        }

        // 清除之前选择的文件
        this.clearFile();

        // 保存图片文件
        this.selectedImage = file;

        // 创建预览
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
      // 重置input，以便可以再次选择同一文件
      event.target.value = '';
    },
    handleFileSelect(event){
      const file = event.target.files[0];
      if (file) {
        // 检查文件格式（只允许 txt, csv, xlsx）
        const allowedExtensions = ['txt', 'csv', 'xlsx', 'xls'];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
          this.$utils.alertText(this.$t('file_max_size'), 200);
          event.target.value = '';
          return;
        }

        // 检查文件大小（最大5MB）
        const maxSize = 1024 * 1024; // 1MB
        if (file.size > maxSize) {
          this.$utils.alertText(this.$t('max_size'), 200);
          event.target.value = '';
          return;
        }

        // 清除之前选择的图片
        this.clearImage();

        // 保存文件
        this.selectedFile = file;
      }
      // 重置input，以便可以再次选择同一文件
      event.target.value = '';
    },
    clearImage(){
      this.selectedImage = null;
      this.imagePreview = '';
      if (this.$refs.photoInput) {
        this.$refs.photoInput.value = '';
      }
    },
    clearFile(){
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },

	}
}
</script><style scoped>
.home-page-bot {
  /* height: 100%; */
  /* display: flex; */
  /* overflow: hidden; */
  background: #02051b;
}

.back-btn {
  padding: 0.2rem;
  position: absolute;
  z-index: 1;
}

.chat-container {
  padding: 0.2rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  position: relative;
  height: 15rem;
  width: 100%;
  overflow: hidden;
}

.message-list {
  overflow-y: auto;
  height: calc(100% - 0.7rem);
  width: 100%
}

.input-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #101324;
  border-top: 0.01rem solid #333;
  padding: 0.1rem;
  /* 适配iOS安全区域 */
  padding-bottom: calc(0.1rem + env(safe-area-inset-bottom));
}

.suggestions {
  display: flex;
  gap: 0.15rem;
  padding: 0.1rem;
  color: #6C7080;
}
.chat-botttom .nav-icon{
  height: 0.9rem;
  width: 0.9rem;}
.chat-botttom{
  height: 1.05rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 90%;
  margin: 0.2rem auto;    justify-content: space-between;}
.chat-input-box {
  display: flex;
  align-items: center;
  background: #202342;
  background: url('../../static/images/text_box.png') no-repeat center center;
  background-size: cover;
  box-shadow: 0 0 0.6rem inset #371a7b;
  border-radius: 0.7rem;
  height: 0.9rem;
  width:calc(100% - 1rem);
}

.chat-input {
  flex: 1;
  background: transparent;
  border: none;
  color: white;
  padding: 0.08rem;
  font-size: 0.25rem;
  outline: none;
  margin-left: 0.25rem;
}

input::placeholder {
  color: #fff !important
}

/* 消息气泡样式 */
.message {
  margin: 0.1rem 0;
  display: flex;
}

.message.user {
  justify-content: flex-end;
}

.bubble {
  background: #1b2e6f;
  padding: 0.12rem 0.2rem;
  border-radius: 0.2rem;
  max-width: 70%;
}

.bubble span {
  color: #ffffff;
}

.message.assistant .bubble {
  background: #1b2e6f;
}

/* 适配移动端键盘 */
@media (max-height: 6rem) {
  .message-list {
    padding-bottom: 1.5rem;
    /* 键盘弹出时增加底部空间 */
  }
}

.bubble span {
  display: inline-block;
}

/* 消息中的图片显示 */
.message-image {
  margin-bottom: 0.1rem;
}

.message-image-preview {
  max-width: 100%;
  max-height: 3rem;
  border-radius: 0.15rem;
  object-fit: cover;
  display: block;
}

/* 消息中的文件显示 */
.message-file {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  margin-bottom: 0.1rem;
  padding: 0.1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.1rem;
}

.message-file-icon {
  width: 0.4rem;
  height: 0.4rem;
  flex-shrink: 0;
}

.message-file-name {
  color: #ffffff;
  font-size: 0.24rem;
  word-break: break-all;
}

.message-content {
  display: block;
  margin-top: 0.1rem;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.avatar {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  margin-right: 0.1rem;
  align-self: flex-start;
}

.message.user .avatar {
  margin-left: 0.1rem;
  margin-right: 0;
  order: 2;
}

.send-btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.welcome-box {
  position: absolute;
  top: 3.2rem;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
}


.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 1.88rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.2rem;
  z-index: 10;
  color: white;
}

.nav-left,
.nav-right {
  width: 0.4rem;
  height: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-title {
  font-size: 0.28rem;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  flex: 1;

}

.nav-icon {
  width: 0.41rem;
  height: 0.41rem;
}

.nav-icon-left {
  width: 0.4rem;
  height: 0.38rem;
}
.Delete-Chat{color:#df1f63}
.chances-bt{height: 0.8rem;line-height: 0.8rem;width:100%}

.modal-bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999;
}

/* 底部弹窗样式 */
.bottom-sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2a1f4a;
  border-radius: 0.4rem 0.4rem 0 0;
  z-index: 1001;
  transform: translateY(100%);
  transition: transform 0.3s ease-out;
  padding-bottom: calc(0.2rem + env(safe-area-inset-bottom));
}

.bottom-sheet.show {
  transform: translateY(0);
}

.bottom-sheet-handle {
  width: 2rem;
  height: 0.08rem;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 0.04rem;
  margin: 0.2rem auto;
  cursor: pointer;
}

.bottom-sheet-content {
  padding: 0.3rem 0.4rem;
}

.upload-options {
  display: flex;
  gap: 0.3rem;
  justify-content: space-between;
}

.upload-btn {
  flex: 1;
  background: linear-gradient(135deg, #7b3fe4 0%, #5a2db8 100%);
  border-radius: 0.3rem;
  padding: 0.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  cursor: pointer;
  transition: opacity 0.2s;
  min-height: 1.5rem;
}

.upload-btn:active {
  opacity: 0.8;
}

.upload-icon {
  width: 0.6rem;
  height: 0.6rem;
}

.upload-btn span {
  color: #ffffff;
  font-size: 0.28rem;
  font-weight: 500;
}

/* New Chat 按钮样式 */
.new-chat-btn {
  margin-top: 0.3rem;
  padding: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  background: rgba(223, 31, 99, 0.2);
  border-radius: 0.3rem;
  cursor: pointer;
  transition: opacity 0.2s;
}

.new-chat-btn:active {
  opacity: 0.8;
}

.new-chat-icon {
  width: 0.4rem;
  height: 0.4rem;
}

.new-chat-btn span {
  color: #df1f63;
  font-size: 0.28rem;
  font-weight: 500;
}

/* 文件预览区域样式 */
.file-preview-area {
  position: fixed;
  bottom: 1.3rem;
  left: 0;
  right: 0;
  padding: 0.2rem;
  background: rgba(26, 46, 111, 0.95);
  z-index: 998;
  display: flex;
  gap: 0.2rem;
  flex-wrap: wrap;
  max-height: 3rem;
  overflow-y: auto;
}

.preview-item {
  position: relative;
  display: flex;
  align-items: center;
  background: #1b2e6f;
  border-radius: 0.2rem;
  padding: 0.15rem;
  gap: 0.15rem;
}

.preview-image {
  width: 1.5rem;
  height: 1.5rem;
  object-fit: cover;
  border-radius: 0.1rem;
}

.preview-file-icon {
  width: 0.5rem;
  height: 0.5rem;
}

.preview-file-name {
  color: #ffffff;
  font-size: 0.24rem;
  max-width: 2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview-close {
  position: absolute;
  top: -0.1rem;
  right: -0.1rem;
  width: 0.4rem;
  height: 0.4rem;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  color: #ffffff;
  font-size: 0.3rem;
  line-height: 0.4rem;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/snapbot.vue